import * as React from "react";
import { cn } from "../../lib/utils";
import { Input } from "./input";

/**
 * Search field with RTL leading 🔍 affordance.
 * Composes Input `variant="search"` — pass value/onChange/placeholder/id as usual.
 */
const SearchInput = React.forwardRef(
  ({ className, inputClassName, ...props }, ref) => (
    <div className={cn("relative flex w-full items-center", className)}>
      <span
        className="pointer-events-none absolute right-2.5 text-sm text-slate-400"
        aria-hidden="true"
      >
        🔍
      </span>
      <Input
        ref={ref}
        type="text"
        variant="search"
        className={cn("w-full pr-8", inputClassName)}
        {...props}
      />
    </div>
  ),
);
SearchInput.displayName = "SearchInput";

export { SearchInput };
